module.exports = __webpack_public_path__ + "media/images/icons/icn_026-150e7bd4189fc0bae987ce7328ff90c9.svg";